import { Box } from "@/components/ui/box"
import { Button, ButtonText } from "@/components/ui/button"
import { HStack } from "@/components/ui/hstack"
import { Text } from "@/components/ui/text"
import { VStack } from "@/components/ui/vstack"
import { Colors } from "@/constants/Colors"
import { LucideIcon, Sparkles } from "lucide-react-native"
import { View } from "react-native"

type EmptyStateProps = {
  icon: LucideIcon
  title: string
  description: string
  actionLabel?: string
  onAction?: () => void
  color?: string
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  color = Colors.dark.primary,
}: EmptyStateProps) {
  return (
    <Box
      className="overflow-hidden rounded-3xl border p-5"
      style={{
        backgroundColor: `${color}10`,
        borderColor: `${color}44`,
        shadowColor: color,
        shadowOpacity: 0.14,
        shadowRadius: 18,
        shadowOffset: { width: 0, height: 10 },
      }}
    >
      <View
        className="absolute -right-8 -top-8 h-24 w-24 rounded-full"
        style={{ backgroundColor: `${color}18` }}
      />
      <HStack className="items-start gap-4">
        <Box
          className="h-14 w-14 items-center justify-center rounded-2xl border"
          style={{ backgroundColor: `${color}20`, borderColor: `${color}55` }}
        >
          <Icon color={color} size={22} />
        </Box>
        <VStack className="flex-1 gap-2">
          <HStack
            className="self-start items-center gap-1 rounded-full px-2 py-1"
            style={{ backgroundColor: `${color}18` }}
          >
            <Sparkles color={color} size={12} />
            <Text className="text-[10px] font-bold" style={{ color }}>
              COACHING MOMENT
            </Text>
          </HStack>
          <Text className="text-lg font-bold text-white">{title}</Text>
          <Text className="leading-5" style={{ color: Colors.dark.textSecondary }}>
            {description}
          </Text>
          {actionLabel && onAction ? (
            <Button
              size="sm"
              className="mt-2 self-start rounded-full"
              style={{ backgroundColor: color }}
              onPress={onAction}
            >
              <ButtonText className="font-bold" style={{ color: Colors.dark.primaryForeground }}>
                {actionLabel}
              </ButtonText>
            </Button>
          ) : null}
        </VStack>
      </HStack>
    </Box>
  )
}
